import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { success } from '@services/toast-service'
import { removeAuth } from '@utils/removeAuth'
import { loginAction, changePasswordAction, resetPasswordAction, loadUserInfo } from './asynAction'

const initialState: TAuthDetail.State = {
  informationAuthed: {
    email: '',
    id: '',
    jwtToken: '',
    refreshToken: '',
    storeIds: [],
    username: ''
  },
  user: {
    email: '',
    fullName: '',
    note: '',
    roles: [],
    status: 0,
    storeIds: [],
    userId: '',
    userName: ''
  },
  isLoggingIn: false,
  isLoggedIn: false,
  isSubmitingChangePwd: false,
  isSubmitingResetPwd: false
}

const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    setUser (state, action: PayloadAction<TAuthDetail.State['user']>) {
      state.user = action.payload
    },
    setIsLoggingIn (state, action: PayloadAction<boolean>) {
      state.isLoggingIn = action.payload
    },
    setIsLogedIn (state, action: PayloadAction<boolean>) {
      state.isLoggedIn = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(loginAction.fulfilled, (state, action: PayloadAction<TAuthDetail.State['informationAuthed']>) => {
        if (!action.payload) return

        const { statusCode } = action.payload

        if (statusCode && statusCode > 400) return

        const isSuccess = !!action.payload
        state.informationAuthed = action.payload
        state.isLoggingIn = isSuccess
        state.isLoggedIn = isSuccess
      })
      .addCase(loginAction.pending, state => {
        state.isLoggingIn = true
      })
      .addCase(loginAction.rejected, state => {
        state.isLoggingIn = false
        state.isLoggingIn = false
      })
    builder.addCase(loadUserInfo.fulfilled, (state, action) => {
      state.user = action.payload
    })
    builder
      .addCase(changePasswordAction.fulfilled, (state, action: PayloadAction<ApiResponse>) => {
        state.isSubmitingChangePwd = false
        if (!action.payload?.errors?.length) {
          success('パスワードを再発行しました。メールを確認してください。')
        }
      })
      .addCase(changePasswordAction.pending, state => {
        state.isSubmitingChangePwd = true
      })
      .addCase(changePasswordAction.rejected, state => {
        state.isSubmitingChangePwd = false
      })
    builder
      .addCase(resetPasswordAction.fulfilled, (state, action: PayloadAction<ApiResponse>) => {
        state.isSubmitingResetPwd = false
        if (!action.payload?.errors?.length) {
          success('パスワードのリセットが完了しました。メールを確認してください。')
          removeAuth()
        }
      })
      .addCase(resetPasswordAction.pending, state => {
        state.isSubmitingResetPwd = true
      })
      .addCase(resetPasswordAction.rejected, state => {
        state.isSubmitingResetPwd = false
      })
  }
})

export const {
  setUser,
  setIsLogedIn,
  setIsLoggingIn
} = authSlice.actions

export * from './asynAction'

export const authReducer = authSlice.reducer
